export default __webpack_public_path__ + "static/media/auth_bg.f55c4fce.jpg";